module.exports = "/static/media/article02.47d38af1.jpg";